import React, { Component } from 'react'
import { Button, Form, Radio, Input, Tag, Row, Col, Icon, Spin, Modal } from 'antd'
import { compose, graphql, withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
// import queryString from 'query-string'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
// import _intersect from 'lodash/intersect'
import moment from 'moment'

import { FormattedMessage, injectIntl } from 'react-intl'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import PrivilegeInput from '~/App/components/PrivilegeInput'
import eventRegisterFromSlugQuery from '~/App/graphql/queries/eventRegisterFromSlug.gql'
import checkGroupNameAvailableQuery from '~/App/graphql/queries/checkGroupNameAvailable.gql'
import createRegistrationMutation from '~/App/graphql/mutations/createRegistration.gql'
import createParticipantMutation from '~/App/graphql/mutations/createParticipant.gql'
import verifyCouponCodeQuery from '~/App/graphql/queries/verifyCouponCode.gql'
import verifyPrivilegeQuery from '~/App/graphql/queries/verifyPrivilege.gql'
import localeGet from '~/App/utils/localeGet'
import './styles.css'
import EventNotFound from '../../Error/EventNotfound'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: {
      span: 6
      // offset: 6
    }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: {
      span: 18
    }
  }
}

class EventRegister extends Component {
  submitting = false
  hiddenSubmitBtn = false
  state = {
    submitting: false,
    privilegeInfo: ''
  }
  handleBypassOneRegType = ({registrationTypes, regTypeId, full}) => {
    const { data, createRegistration, history } = this.props
    const isOneRegType = _get(registrationTypes, 'length') === 1 &&
    registrationTypes.length > 0 &&
    registrationTypes.filter(rt => !rt.couponCodeEnabled).length === 1 &&
      regTypeId && !this.submitting
    const eventId = _get(data, 'event._id')
    if (isOneRegType) {
      if (full) {
        this.hiddenSubmitBtn = true
        return false
      }
      const record = {
        registrationTypeId: regTypeId,
        eventId,
        couponCodeIds: []
      }
      this.submitting = true
      createRegistration({
        variables: {
          record
        }
      }).then(res => {
        const registrationId = _get(res, 'data.registerEvent.record._id')
        if (registrationId) {
          history.replace(`/reg/${registrationId}/preview`)
        }
      }).catch(e => {
        console.error(e)
        Modal.info({
          title: 'error',
          content: <p>{e.message}</p>
        })
      }).finally(() => { this.submitting = false })
    }
  }
  handleRegistration = e => {
    e.preventDefault()
    const { data, createRegistration, history } = this.props
    const registrationTypeId = e.target.getAttribute('registrationTypeId')
    const eventId = _get(data, 'event._id')
    const record = {
      registrationTypeId,
      eventId,
      couponCodeIds: []
    }
    this.submitting = true
    createRegistration({
      variables: {
        record
      }
    }).then(res => {
      const registrationId = _get(res, 'data.registerEvent.record._id')
      if (registrationId) {
        history.push(`/reg/${registrationId}/preview`)
      }
    }).catch(e => {
      console.error(e)
      Modal.info({
        title: 'error',
        content: <p>{e.message}</p>
      })
    }).finally(() => { this.submitting = false })
  }
  handleCreateRegistration = e => {
    e.preventDefault()
    const { form: { validateFields }, createRegistration, history } = this.props
    const regTypes = this.props.data.event.registrationTypes
    validateFields({ force: true }, (err, data) => {
      // console.log({err, data})
      const { record } = data
      const selectedRegType = regTypes.find(regType => regType._id === record.registrationTypeId)
      const deliveryOneAddressEnabled = !!_get(selectedRegType, 'deliveryOptions', []).find(d => d.enabled === true)
      // return
      if (!err) {
        this.setState({
          submitting: true
        })
        createRegistration({
          variables: {
            record
          }
        }).then(res => {
          const registrationId = _get(res, 'data.registerEvent.record._id')
          this.setState({
            submitting: false
          })
          if (registrationId) {
            if (deliveryOneAddressEnabled) {
              history.push(`/reg/${registrationId}/preview`)
            } else {
              history.push(`/reg/${registrationId}/preview?pId=new`)
            }
          }
        })
        // createRegistration({
        //   variables: {
        //     record
        //   }
        // }).then(res => {
        //   const registrationId = _get(res, 'data.registerEvent.record._id')
        //   let createParticipants$ = [] // TODO: should handle server side
        //   if (regType.minParticipants) {
        //     createParticipants$ = [...Array(regType.minParticipants)].map(() => {
        //       return createParticipant({
        //         variables: {
        //           record: {
        //             registrationId,
        //             eventId,
        //             profile: {}
        //           }
        //         }
        //       })
        //     })
        //   }
        //   Promise.all(createParticipants$).then(() => {
        //     if (registrationId) {
        //       history.push(`/reg/${registrationId}/edit?pId=new`)
        //     }
        //   })
        // })
      }
    })
  }

  groupNameValidator = (rule, value, callback) => {
    const { client, intl, data } = this.props
    const eventId = _get(data, 'event._id')
    // console.log({ value })
    if (!value) return callback()
    client.query({
      query: checkGroupNameAvailableQuery,
      fetchPolicy: 'network-only',
      variables: {
        eventId,
        groupName: value
      }
    }).then(({ data: { checkGroupNameAvailable } }) => {
      // console.log({ checkGroupNameAvailable })
      checkGroupNameAvailable ? callback() : callback(
        intl.formatMessage({
          id: 'app.groupNameUnavailable',
          defaultMessage: 'Group Name not Available'
        })
      )
    })
  }

  handleCouponCodeTextChange = () => e => {
    const { resetFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    resetFields([
      `record.couponCodeIds`
    ])
  }

  checkCouponCode = () => {
    const { validateFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    validateFields(
      [
        `__couponCodeText`
      ],
      { force: true }
    )
  }

  couponCodeValidator = (rule, value, callback) => {
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log({ rule, value })
    const { i18n: { locale } } = this.props
    if (!value) return callback()
    // const { fullField } = rule
    // const [, groupIndex] = fullField.split('.')
    const {
      form: { getFieldValue, setFieldsValue, resetFields },
      client,
      data,
      intl
    } = this.props
    const eventId = _get(data, 'event._id')
    // console.log({ eventId })
    client
      .query({
        query: verifyCouponCodeQuery,
        fetchPolicy: 'network-only',
        variables: {
          code: value,
          eventId
        }
      })
      .then(
        ({ data: { verifyCouponCode } }) => {
          // console.log({verifyCouponCode})
          const registrationTypeId = getFieldValue(
            `record.registrationTypeId`
          )
          const { _id, couponCodeType: { masterIds, name } } = verifyCouponCode
          // console.log(productTypeIds, registrationTypeId)
          // const registrationType = registrationTypes.find(tt => tt._id === registrationTypeId)
          // console.log({ masterIds, registrationTypeId, _id })
          if (masterIds.includes(registrationTypeId)) {
            setFieldsValue({
              [`__couponCodeInfo`]: (
                <span>
                  <Icon type="check-circle" /><em>{value}: {localeGet(name, '', locale)}</em>
                </span>
              ),
              [`record.couponCodeIds`]: [_id]
            })
            callback()
          } else {
            const message = 'Incorrect registration type'
            callback(message)
          }
        },
        e => {
          // console.dir(e)
          if (e.graphQLErrors) {
            resetFields([`__couponCodeInfo`])
            e.graphQLErrors.forEach(error => callback(
              intl.formatMessage({ id: `api.${error.message}`, defaultMessage: '' })
            ))
            // callback(e.graphQLErrors)
          } else {
            callback()
          }
          // message.error(e.message)
        }
      )
  }
  checkPrivilege = () => {
    const { validateFields } = this.props.form
    // console.log('checking...')
    // const regTypeId = getFieldValue('registrationTypeId')
    validateFields(
      [
        `__privilege`
      ],
      { force: true }
    )
  }
  privilegeValidator = async (rule, value, callback) => {
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log({ rule, value })
    // const { i18n: { locale } } = this.props
    if (!value) return callback()
    // const { fullField } = rule
    // const [, groupIndex] = fullField.split('.')
    // console.log({ value })
    const { firstName, lastName, privilegeKeys } = value
    // return
    const {
      form: { setFieldsValue },
      client,
      data,
      intl
    } = this.props
    const eventId = _get(data, 'event._id')
    // console.log({ eventId })
    try {
      const { data: { verifyPrivilege } } = await client.query({
        query: verifyPrivilegeQuery,
        fetchPolicy: 'network-only',
        variables: {
          eventId,
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          privilegeKeys
        }
      })
      // console.log({ verifyPrivilege })
      const { _id, profile, bibNumber } = verifyPrivilege
      this.setState({
        privilegeInfo: `[${bibNumber}] ${profile.firstName} ${profile.lastName}`
      })
      setFieldsValue({
        'record.privilegeId': _id
      })
    } catch (e) {
      const { graphQLErrors = [] } = e
      // console.log({ graphQLErrors })
      this.setState({
        privilegeInfo: ''
      }, () => {
        graphQLErrors.forEach(error => callback(
          intl.formatMessage({ id: `api.privilegeValidate.${error.message}`, defaultMessage: '' })
        ))
      })
    }
  }
  async UNSAFE_componentWillReceiveProps(nextProps) { // eslint-disable-line
    // const { data } = nextProps
    // const event = _get(data, 'event')
    // const periods = _get(event, 'periods', [])
    // if (event.slug === 'BS21-2018-General' && periods.find(p => moment().isBetween(p.start, p.end))) {
    //   this.props.history.replace(`/${event.slug}`)
    // }
  }

  registrationTypeValidator = (rule, value, callback) => {
    // console.log('this.props', this.props)
    const event = _get(this.props.data, 'event')
    const intl = _get(this.props, 'intl')
    const registrationTypes = _get(event, 'registrationTypes', [])
    const regTypeId = value
    const regType = registrationTypes.find(t => t._id === regTypeId)
    const ticketsQuota = _get(event, 'ticketsQuota', [])
    const ticketLimitReached = ticketsQuota.reduce((result, rec) => {
      result[rec._id] = rec.limit > 0 && rec.count >= rec.limit
      return result
    }, {})
    const full = regType.limitId && ticketLimitReached[regType.limitId]
    // console.log('registrationTypeValidator')
    if (full) {
      // return callback('This Registration Type is full')
      return callback(intl.formatMessage({ id: 'app.regTypeFull', defaultMessage: 'Registration Type Full' }))
    }
    callback()
  }

  render () {
    const { data, form, i18n: { locale }, intl, showHiddenTypes } = this.props
    // console.log({ showHiddenTypes })
    const { getFieldDecorator, getFieldValue } = form
    // getFieldsError
    const event = _get(data, 'event')
    if (data.loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (!event) {
      return <EventNotFound />
    }
    const periods = _get(event, 'periods', [])
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const currentPeriods = periods.filter(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // showHiddenTypes -> hidden
    // !show -> !hidden
    // console.log(_get(data, 'event.registrationTypes', []))
    const registrationTypes = _get(event, 'registrationTypes', []).filter(type =>
      periods &&
      type.periodIds.map(id =>
        periods.find(p => p._id === id)
      ).find(p =>
        p && (moment().isBetween(p.start, p.end) || moment().isBetween(p.preRegisterStart, p.preRegisterEnd))
      )
    ).filter(type => !!showHiddenTypes !== !type.hidden)
    // console.log({ registrationTypes }, _get(event, 'registrationTypes'))
    // const hasRegTypes = registrationTypes.length > 0
    let $registrationTypes
    let $registrationFields
    getFieldDecorator('record.eventId', {
      initialValue: _get(data, 'event._id')
    })
    const registrationFields = _get(data, 'event.settings.registration.fields', []) || []
    const regFields = registrationFields
      .filter(f => f.enabled)
      .reduce((result, field) => {
        result[field.name] = field
        return result
      }, {})
    const ticketsQuota = _get(event, 'ticketsQuota', [])
    const ticketLimitReached = ticketsQuota.reduce((result, rec) => {
      result[rec._id] = rec.limit > 0 && rec.count >= rec.limit
      return result
    }, {})
    const regTypeDecorator = getFieldDecorator('record.registrationTypeId', {
      initialValue: registrationTypes.length === 1 ? _get(registrationTypes, [0, '_id']) : null,
      rules: [
        { required: true, message: 'Please select registration Type' },
        { validator: this.registrationTypeValidator }
      ]
    })
    // console.log({registrationTypes})
    const regTypeId = getFieldValue('record.registrationTypeId')
    const regType = registrationTypes.find(t => t._id === regTypeId)
    const couponCodeEnabled = _get(regType, 'couponCodeEnabled')
    const couponCodeRequired = _get(regType, 'couponCodeRequired')
    const privilegeKeys = _get(regType, 'privilegeKeys', []) || []
    // console.log({ couponCodeRequired })
    getFieldDecorator('record.couponCodeIds', { initialValue: [] })
    getFieldDecorator('record.privilegeId')
    // if (hasRegTypes) {
    $registrationTypes = (
      <Form.Item >
        {regTypeDecorator(
          <Radio.Group
            className="radioGroupBtn"
            onChange={this.handleChangeRegType}
          >
            {_sortBy(registrationTypes, ['_id']).map(regType => {
              const full = regType.limitId && ticketLimitReached[regType.limitId]
              this.handleBypassOneRegType({registrationTypes, regTypeId, full})
              return <Radio
                className="registrationTypeRadio"
                key={regType._id}
                value={regType._id}
                disabled={full}
                style={{ marginBottom: '.5em' }}
              >
                {full && <Tag color="red">
                  {{ en: 'Full', zh: 'Full', th: 'เต็ม' }[locale]}
                </Tag>}
                {localeGet(regType, 'name', locale)}
                <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                  {localeGet(regType, 'infoMessage', locale) &&
                    <span className="registrationTypeInfo"
                      style={{
                        display: 'inline-block',
                        lineHeight: '1.5em',
                        whiteSpace: 'pre-line',
                        color: 'grey'
                        // marginTop: '-.5em'
                      }}
                    >{localeGet(regType, 'infoMessage', locale)}</span>
                  }
                </div>
              </Radio>
            })}
          </Radio.Group>
        )}
      </Form.Item>
    )
    $registrationFields = (
      <div>
        {regFields['groupName'] &&
          <Form.Item label={<FormattedMessage id="app.groupName" defaultMessage="Group Name" />} {...formItemLayout}>
            {getFieldDecorator('record.groupName', {
              // validateTrigger: ['onChange'],
              validateTrigger: ['onBlur'],
              validateFirst: true,
              rules: [{
                required: regFields['groupName'].required, message: intl.formatMessage({ id: 'app.groupNameEmpty', defaultMessage: 'Group Name Empty' })
              // }, {
              //   validator: this.groupNameValidator // TODO: only unique
              }]
            })(<Input />)}
          </Form.Item>
        }
      </div>
    )
    const couponCodeText = getFieldValue(
      `__couponCodeText`
    )
    const privilege = getFieldValue(
      `__privilege`
    )
    getFieldDecorator(`__couponCodeInfo`)
    const couponCodeInfo = getFieldValue(
      `__couponCodeInfo`
    )
    // }
    return <div className="EventRegisterPage">
      {event.testMode && <div className="testMode">
        <Tag color="red">
          Test mode !!!
        </Tag>
      </div>}
      <div className="innerEventRegisterPage">
        <div className="dividedBox">
          <div className="registrationTopTitle">
            {localeGet(event, 'name', locale)}
          </div>
          <RegistrationSteps step="register" />
        </div>
        <div className="selectRegTypeContent" style={{display: 'none'}}>
          <h1>
            <FormattedMessage id="app.registrationType" defaultMessage="Registration Type" />
          </h1>
          {_sortBy(registrationTypes, ['_id']).map(regType => {
            const full = regType.limitId && ticketLimitReached[regType.limitId]
            return <Button type="primary"
              disabled={full}
              onClick={this.handleRegistration}
              key={regType._id}
              // registrationTypeId={regType._id}
              className="registrationTypeOption"
            >
              { full && { en: 'Full', zh: 'Full', th: 'เต็ม' }[locale] }
              {localeGet(regType, 'name', locale)}
            </Button>
          })}
        </div>
        <Form onSubmit={this.handleCreateRegistration}>
          <div style={{ maxWidth: '1000px', margin: 'auto' }}>
            <div className="dividedBox">
              <h1>
                <FormattedMessage id="app.registrationType" defaultMessage="Registration Type" />
              </h1>
              {$registrationTypes}
              {$registrationFields}
              {couponCodeEnabled &&
            <Form.Item label={{ en: 'Code', th: 'Code' }[locale]}
              {...formItemLayout}
              extra={couponCodeInfo}
            >
              <Row gutter={8}>
                <Col span={18}>
                  {getFieldDecorator(
                    `__couponCodeText`,
                    {
                      validateTrigger: [],
                      rules: [{
                        required: couponCodeRequired, message: intl.formatMessage({ id: 'app.couponCodeRequired', defaultMessage: 'Please enter Code' })
                      }, {
                        validator: this.couponCodeValidator
                      }],
                      onChange: () =>
                        this.handleCouponCodeTextChange()
                    }
                  )(<Input />)}
                </Col>
                <Col span={6}>
                  <Button disabled={!couponCodeText} onClick={e => this.checkCouponCode()}>
                    Check
                  </Button>
                </Col>
              </Row>
            </Form.Item>}
              {privilegeKeys.length > 0 &&
            <Form.Item label={{ en: 'First Name - Last Name', th: 'ชื่อ - สกุล' }[locale]}
              {...formItemLayout}
              extra={this.state.privilegeInfo}
            >
              <Row gutter={8}>
                <Col span={18}>
                  {getFieldDecorator(
                    `__privilege`,
                    {
                      validateTrigger: [],
                      rules: [{
                        required: true,
                        message: intl.formatMessage({ id: 'app.privilegeRequired', defaultMessage: 'Please enter your name' })
                      }, {
                        validator: this.privilegeValidator
                      }]
                      // onChange: () =>
                      //   this.handleCouponCodeTextChange()
                    }
                  )(<PrivilegeInput privilegeKeys={privilegeKeys} />)}
                </Col>
                <Col span={6}>
                  <Button disabled={!privilege || !privilege.firstName || !privilege.lastName} onClick={e => this.checkPrivilege()}>
                    Check
                  </Button>
                </Col>
              </Row>
            </Form.Item>}

              <div style={{ padding: '8px', textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                {localeGet(data, 'event.settings.registrationType.customMessage', locale)}
              </div>
              <div style={{ padding: '8px', textAlign: 'right' }}>
                <Button type="primary" htmlType="submit" loading={this.state.submitting} disabled={this.hiddenSubmitBtn}>
                  <FormattedMessage id="app.next" defaultMessage="Next"/>
                </Button>
              </div>
            </div>
          </div>
          {/* <Button htmlType="submit">Submit</Button> */}
        </Form>
      </div>
    </div>
  }
}

export default compose(
  Form.create(),
  withApollo,
  graphql(eventRegisterFromSlugQuery, {
    options: ({ match: { params: { eventSlug } } }) => ({
      variables: { slug: eventSlug },
      fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, eventRegisterFromSlug } }) => ({
      data: {
        loading,
        event: eventRegisterFromSlug
      }
    })
  }),
  graphql(createRegistrationMutation, {
    name: 'createRegistration'
  }),
  graphql(createParticipantMutation, {
    name: 'createParticipant'
  }),
  inject('i18n'),
  injectIntl,
  observer
)(EventRegister)



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/EventRegister/EventRegister.js